module.exports = __webpack_public_path__ + "static/media/infinity.370eaeed.svg";